import React from 'react';
import { motion } from 'framer-motion';
import { Check, Sparkles } from 'lucide-react';
import { SectionEyebrow } from './SectionEyebrow';
import { CoverImage } from './CoverImage';
import { trackInitiateCheckout } from '../lib/metaPixel';
const IMAGES = {
  main: 'https://cdn.magicpatterns.com/uploads/k66PeTHA9hMBB1F8f8BeHQ/42AD1564-0724-4E06-956B-1E54FA235ABC.png',
  bonus1: 'https://cdn.magicpatterns.com/uploads/nhed4qrh1e2fpNSZrdGvyC/Gemini_Generated_Image_o3coy2o3coy2o3co.png',
  bonus2: 'https://cdn.magicpatterns.com/uploads/dSf1KMiKPp2oVvK3GHV7AG/ChatGPT_Image_6_may_2026,_01_19_02_a.m._(1).png',
  bonus3: 'https://cdn.magicpatterns.com/uploads/5MGNjuQNrJY9EmSncq3zok/ChatGPT_Image_6_may_2026,_01_19_02_a.m._(2).png'
};
export function BundleOffer() {
  return <section id="oferta" className="py-20 md:py-32 px-6 bg-card relative overflow-hidden" data-id="element-12">
      {/* Ornamental borders */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-accent/40 to-transparent" data-id="element-13"></div>
      <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-accent/40 to-transparent" data-id="element-14"></div>

      <div className="container max-w-[900px] mx-auto" data-id="element-15">
        <div className="text-center mb-12 md:mb-16" data-id="element-16">
          <SectionEyebrow text="El momento es ahora" className="mb-4" data-id="element-17" />
          <h2 className="text-4xl md:text-6xl text-foreground leading-[1.05] font-serif" data-id="element-18">
            Conviértete en{' '}
            <span className="italic text-muted-foreground" data-id="element-19">esa mujer.</span>
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-light max-w-xl mx-auto mt-8 leading-relaxed" data-id="element-20">
            Tu nueva versión no se construye sola. Se elige. Hoy puede ser el
            día en que dejes de posponerte.
          </p>
        </div>

        {/* Hero Shot Flatlay */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="flex justify-center items-center -space-x-6 md:-space-x-12 mb-12 md:mb-16" data-id="element-21">
          <div className="w-24 md:w-40 z-10" data-id="element-22">
            <CoverImage src={IMAGES.bonus1} alt="Bono 1" rotation={-12} hoverEffect={false} data-id="element-23" />
          </div>
          <div className="w-36 md:w-60 z-30 shadow-2xl" data-id="element-24">
            <CoverImage src={IMAGES.main} alt="Principal" rotation={0} hoverEffect={false} data-id="element-25" />
          </div>
          <div className="w-24 md:w-40 z-20" data-id="element-26">
            <CoverImage src={IMAGES.bonus2} alt="Bono 2" rotation={8} hoverEffect={false} data-id="element-27" />
          </div>
          <div className="w-20 md:w-36 z-10 hidden md:block" data-id="element-28">
            <CoverImage src={IMAGES.bonus3} alt="Bono 3" rotation={15} hoverEffect={false} data-id="element-29" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-background rounded-3xl p-6 md:p-12 shadow-soft border border-border relative" data-id="element-30">
          <div className="space-y-3 mb-8 max-w-md mx-auto" data-id="element-31">
            {[{
            name: 'Glow Up Femenino en 30 Días',
            value: '$499 USD'
          }, {
            name: 'Eleva tus estándares y honra tu valor',
            value: '$200 USD'
          }, {
            name: 'Diario de sanación y claridad',
            value: '$200 USD'
          }, {
            name: 'Declaraciones para volver a ti',
            value: '$100 USD'
          }].map((item, i) => <div key={i} className="flex items-center justify-between py-2 gap-3" data-id="element-32">
                <div className="flex items-center gap-3 min-w-0" data-id="element-33">
                  <Check className="w-4 h-4 text-accent shrink-0" strokeWidth={2} data-id="element-34" />
                  <span className="text-foreground font-light text-sm md:text-base truncate" data-id="element-35">
                    {item.name}
                  </span>
                </div>
                <span className="font-serif text-muted-foreground italic text-sm md:text-base shrink-0" data-id="element-36">
                  {item.value}
                </span>
              </div>)}
          </div>

          <div className="flex flex-col items-center text-center bg-card rounded-2xl p-8 md:p-10 mb-8 border border-border/50" data-id="element-37">
            <p className="text-base font-serif text-muted-foreground line-through opacity-60 mb-1" data-id="element-38">
              Valor total $999 USD
            </p>
            <p className="text-xs uppercase tracking-[0.2em] text-accent mt-4 mb-2" data-id="element-39">
              Hoy solo
            </p>
            <p className="text-6xl md:text-8xl font-serif text-foreground leading-none" data-id="element-40">
              $19.99 <span className="text-2xl md:text-3xl" data-id="element-41">USD</span>
            </p>
          </div>

          <div className="flex flex-col items-center gap-5" data-id="element-42">
            <a href="https://bypaolarojas.com/products/glow-up-femenino-en-30-dias?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout()} className="w-full md:w-auto bg-primary text-primary-foreground px-10 md:px-14 py-5 md:py-6 rounded-full font-sans text-lg md:text-xl tracking-wide hover:bg-primary/90 transition-all duration-300 shadow-soft hover:shadow-lg hover:-translate-y-1 text-center inline-block" data-id="element-43">
              Quiero volver a mí
            </a>

            <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs uppercase tracking-widest text-muted-foreground" data-id="element-44">
              <span data-id="element-45">Acceso inmediato</span>
              <span className="w-1 h-1 rounded-full bg-accent/50 self-center" data-id="element-46"></span>
              <span data-id="element-47">Pago seguro</span>
              <span className="w-1 h-1 rounded-full bg-accent/50 self-center" data-id="element-48"></span>
              <span data-id="element-49">Formato 100% digital</span>
            </div>

            <p className="font-serif italic text-muted-foreground text-base md:text-lg flex items-center gap-2 mt-2" data-id="element-50">
              <Sparkles className="w-4 h-4 text-accent" strokeWidth={1.5} data-id="element-51" />
              Una decisión. Treinta días. Una nueva mujer.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}